<div class="p-4">
  <h3
    *ngIf="showHeading && section.type !== SectionType.FINANCIAL_PERFORMANCE"
    class="mb-4 text-xl font-bold text-[#1E2A78]"
  >
    {{ sectionTitleKey(section.title) | translate }}
  </h3>

  <ng-container [ngSwitch]="section.type">
    <!-- Highlights -->
    <app-bullet-list-section
      *ngSwitchCase="SectionType.BULLET_LIST"
      [items]="sectionConfig['items']"
      [editable]="isEditMode"
    >
    </app-bullet-list-section>

    <!-- Paragraph -->
    <app-paragraph-section
      *ngSwitchCase="SectionType.PARAGRAPH"
      [paragraphs]="sectionConfig['paragraphs']"
      [editable]="isEditMode"
      [refValSeq]="sectionConfig['refValSeq']"
      [sectionId]="section.id"
    >
    </app-paragraph-section>

    <!-- Income Statement -->
    <app-income-statement-type-credit-proposal
      *ngSwitchCase="SectionType.INCOME_STATEMENT_TYPE_CREDIT_PROPOSAL"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
    >
    </app-income-statement-type-credit-proposal>

    <!-- Institutional KPIs -->
    <app-kpi-card-section
      *ngSwitchCase="SectionType.KPI"
      [items]="sectionConfig['items']"
      [editable]="isEditMode"
    >
    </app-kpi-card-section>
    <!-- Repayment Plan -->
    <app-repayment-plan
      *ngSwitchCase="SectionType.REPAYMENT_PLAN"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
    >
    </app-repayment-plan>

    <!-- Calculate Repayment Plan -->
    <app-calculate-repayment-plan
      *ngSwitchCase="SectionType.CALCULATE_REPAYMENT_PLAN"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
    >
    </app-calculate-repayment-plan>
    <app-institutional-rating-builder
      *ngSwitchCase="SectionType.IRS_RATING"
      [sectionId]="section.id"
      [editable]="isEditMode"
      [refGrp]="sectionConfig['refGrp']"
      [refValSeq]="sectionConfig['refValSeq']"
      [crdtPrpslSeq]="crdtPrpslSeq"
    >
    </app-institutional-rating-builder>
    <app-borrow-perposal-review
      *ngSwitchCase="SectionType.BORROW_PERPOSAL_REVIEW"
      [sectionId]="section.id"
      [editable]="isEditMode"
      [refGrp]="sectionConfig['refGrp']"
      [refValSeq]="sectionConfig['refValSeq']"
    ></app-borrow-perposal-review>
    <!-- Credit Proposal Extra Types -->
    <app-credit-proposal-extra-type
      *ngSwitchCase="SectionType.CREDIT_PROPOSAL_EXTRA_TYPE"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
    >
    </app-credit-proposal-extra-type>

    <!-- Terms Parameter -->
    <app-terms-parameters
      *ngSwitchCase="SectionType.TERMS_PARAMETERS"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
    >
    </app-terms-parameters>

    <!-- Institutional Highlights -->
    <app-financial-data
      *ngSwitchCase="SectionType.Financial_data"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
    >
    </app-financial-data>
    <app-financial-analysis-details
      *ngSwitchCase="SectionType.FINANCIAL_ANALYSIS_DETIALS"
      [sectionId]="section.id"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
    >
    </app-financial-analysis-details>

    <!-- Numbered List -->
    <app-numbered-list-section
      *ngSwitchCase="SectionType.NUMBERED_LIST"
      [items]="sectionConfig['items']"
      [editable]="isEditMode"
    >
    </app-numbered-list-section>
    <app-repayment
      *ngSwitchCase="SectionType.PROPOSED_DISBURSEMENT"
      [sectionId]="section.id"
      [editable]="isEditMode"
      [crdtPrpslSeq]="crdtPrpslSeq"
    >
    </app-repayment>
    <app-disbursement-repayment-summary
      *ngSwitchCase="SectionType.DISBURSEMENT_REPAYMENT_SUMMARY"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
      [editable]="isEditMode"
    ></app-disbursement-repayment-summary>
    <app-credit-proposal-documents
      *ngSwitchCase="SectionType.DOCUMENTS"
      [crdtPrpslSeq]="crdtPrpslSeq"
      [sectionId]="section.id"
      [editable]="isEditMode"
    ></app-credit-proposal-documents>
    <!-- Simple Table -->
    <app-table-section
      *ngSwitchCase="SectionType.TABLE"
      [tableConfig]="tableConfig"
      [editable]="isEditMode"
    >
    </app-table-section>

    <!-- Risks -->
    <app-risk-section
      *ngSwitchCase="SectionType.RISK_SECTION"
      [items]="sectionConfig['items']"
      [editable]="isEditMode"
    >
    </app-risk-section>

    <!-- Summary Terms -->
    <app-summary-terms-section
      *ngSwitchCase="SectionType.SUMMARY_TERMS"
      [items]="sectionConfig['items']"
      [editable]="isEditMode"
    >
    </app-summary-terms-section>

    <!-- IRS Rating -->
    <app-irs-rating-section
      *ngSwitchCase="SectionType.IRS_RATING_SUMRY"
      [config]="sectionConfig"
      [editable]="isEditMode"
      [sectionId]="section.id"
    >
    </app-irs-rating-section>
    <app-recommendations-section
      *ngSwitchCase="SectionType.RECOMMENDATIONS"
      [sectionId]="section.id"
      [editable]="isEditMode"
      [refGrp]="sectionConfig['refGrp']"
      [refValSeq]="sectionConfig['refValSeq']"
    >
    </app-recommendations-section>
    <!-- Financial Performance -->
    <app-financial-performance-section
      *ngSwitchCase="SectionType.FINANCIAL_PERFORMANCE"
      [sectionId]="section.id"
      [editable]="isEditMode"
      [refGrp]="sectionConfig['refGrp']"
      [refValSeq]="sectionConfig['refValSeq']"
    >
    </app-financial-performance-section>

    <!-- Fallback -->
    <ng-container *ngSwitchDefault>
      <div
        *ngIf="onUnsupportedSectionEncountered()"
        role="alert"
        class="rounded-2xl border border-dashed border-amber-300 bg-amber-50 p-6 text-sm text-amber-800"
      >
        <p class="font-semibold">{{ 'CREDIT_SECTION.UNSUPPORTED_TITLE' | translate }}</p>
        <p class="mt-1 text-amber-700">
          {{ 'CREDIT_SECTION.UNSUPPORTED_MESSAGE' | translate: { title: (sectionTitleKey(section.title) | translate), type: section.type } }}
        </p>
      </div>
    </ng-container>
  </ng-container>
</div>
